import { TrackingEventTypes } from '@cinch-nx/shared-analytics'
import { storyblokEditable } from '@cinch-nx/data-storyblok'
import { HomeUspSlide } from '../../types/home-story-content'
import { SvgIcon } from '@cinch-labs/design-system'
import { IconNames } from '@cinch-labs/design-system/dist/src/tokens/tokens.types'

import styles from './usp-slide.module.css'
import { datadogRum } from '@datadog/browser-rum'
import { Datadog } from '@cinch-nx/landing-ui-shared'
import { useAnalytics } from '@cinch-nx/shared-analytics'

const { Context, Actions } = Datadog

export function UspSlide(blok: HomeUspSlide) {
  const { trackEvent } = useAnalytics()
  const { title, text, icon, link } = blok

  type IconNamesUnion = `${IconNames}`
  //Current dev + prod usp icons have mapping just so a migration of the dev datasource to prod doesn't temporarily break the UI
  const mappedIconName: Record<string, IconNamesUnion> = {
    'cinchCare-servicing': 'cinchCare-servicing', //current dev icon - maps to DSv1 icon name
    CinchCareServicingIcon: 'cinchCare-servicing', //current prod icon - maps to DSv2 icon name
    smartphone: 'smartphone', //current dev icon - maps to DSv1 icon name
    SmartPhoneIcon: 'smartphone', //current prod icon - maps to DSv2 icon name
    search: 'search', //current dev icon - maps to DSv1 icon name
    SearchIcon: 'search', //current prod icon - maps to DSv2 icon name
  }

  const handleTrackEvent = () => {
    datadogRum.addAction(Actions.CLICK_USP_LINK, {
      service: Context.HERO_USP,
      squad: Context.SQUAD,
      page: '/',
      category: 'hero',
      label: 'usp-click - below main hero',
      value: `${title} usp-click`,
    })

    trackEvent({
      eventName: `${title} usp-click`,
      type: TrackingEventTypes.ADOBE,
      data: {
        event: {
          name: 'click',
          category: 'hero',
          label: 'below main hero',
          action: `${title}`,
        },
      },
    })
  }

  return (
    <a
      href={link.url}
      className={styles.slideCard}
      {...storyblokEditable(blok)}
      onClick={() => handleTrackEvent()}
    >
      <SvgIcon name={mappedIconName[icon]} color={'vividViolet'} size={24} />
      <h3>{title}</h3>
      <p>{text}</p>
    </a>
  )
}
